// extracted by mini-css-extract-plugin
module.exports = {"nrljournal_banner":"Xg2Er","thin":"rfKxA","btn":"vLm_y","know_more":"LO5ds"};